import { Grid } from '@mui/material';
import { PqrRedirectProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { usePqrRedirect } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';

export const PqrRedirect = ({ redirect }: PqrRedirectProps) => {
    const { formik } = usePqrRedirect(redirect);
    return (
        <Accordion
            title="REDIRECCIONAR PQR"
            icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Área encargada"
                        name="area1"
                        size="small"
                        value={formik.values.area1}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Persona encargada"
                        name="person1"
                        size="small"
                        value={formik.values.person1}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Email"
                        name="email1"
                        size="small"
                        value={formik.values.email1}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Área encargada"
                        name="area2"
                        size="small"
                        value={formik.values.area2}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Persona encargada"
                        name="person2"
                        size="small"
                        value={formik.values.person2}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Email"
                        name="email2"
                        size="small"
                        value={formik.values.email2}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Área encargada"
                        name="area3"
                        size="small"
                        value={formik.values.area3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Persona encargada"
                        name="person3"
                        size="small"
                        value={formik.values.person3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Email"
                        name="email3"
                        size="small"
                        value={formik.values.email3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Redireccionar PQR?"
                        checked={Boolean(formik.values.redirectPqr)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Generar alerta?"
                        checked={Boolean(formik.values.generateAlert)}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
